var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vc-form-group-label",class:_vm.labelClasses,style:({height: _vm.height})},[(_vm.required)?_c('span',{staticClass:"vc-form-group-label-require"},[_vm._v("*")]):_vm._e(),_c('label',[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }